<template>
  <MainContent>
    <b-card>
      <ResetPasswordForm
        :target-url="targetUrl"
        :activation-key="activationKey"
        :new-user="newUser"
      />
    </b-card>
  </MainContent>
</template>

<script>
import MainContent from "../../../components/main/MainContent";
import ResetPasswordForm from "../components/ResetPasswordForm";

export default {
  props: ["targetUrl", "activationKey", "newUser"],
  components: {
    MainContent,
    ResetPasswordForm
  }
};
</script>
